import React, { useEffect, useState } from "react";
import classnames from "classnames";
import style from "./page-layout.module.scss";
import SwiperTracks from "components/ui/swiper-tracks/swiper-tracks";
import AppMenu from "components/ui/app-menu/app-menu";
import useQueryParams from "hooks/use-query-params";
import { generatePath } from "react-router-dom";
import { serializeObjectInUrlQuery } from "helpers/object";
import { isDefined } from "helpers/predicates";
import classNames from "classnames";
import Ubung from "components/ui/ubung/ubung";
import PlayerMetadata from "components/ui/player-metadata/player-metadata";
import PlayerLevel from "components/ui/player-level/player-level";

const PageLayout = ({
  match,
  history,
  trackId,
  viewType,
  ubungen,
  menuItems = [],
  _onSwiper,
  metadata = {},
}) => {
  const [showDetail, setShowDetail] = useState("hide");
  const [isOpen, setIsOpen] = useState(false);
  const objQueryParams = useQueryParams();
  const handleOnClick = (type = "track", id = null) => {
    const { path = "" } = match;
    const pathname = generatePath(path, {
      viewType: type,
      trackId: isDefined(id) ? id : trackId,
    });

    history.push({
      pathname: pathname,
      search: `?${serializeObjectInUrlQuery(objQueryParams)}`,
    });
  };
  useEffect(() => {
    const status = viewType === "detail" ? "show" : "hide";
    setShowDetail(status);
  }, [viewType]);

 

  return (
    <div className={style.root}>
      <div className={classNames(style.left, isOpen && style.isOpen)}>
      <button
          className={classnames(style.navIcon, isOpen && style.isOpen)}
          onClick={() => {
           setIsOpen(!isOpen);
          }}
      >
              <span></span>
              <span></span>
              <span></span>
        </button>
        <PlayerMetadata {...metadata} />
        <PlayerLevel {...metadata} />
        <AppMenu
          menuItems={menuItems}
          trackId={trackId}
          _onClick={(id) => {
            setIsOpen(!isOpen);
            handleOnClick("track", id);
          }}
        />
      </div>
      <div className={classNames(style.main, isOpen && style.isOpen)}>
        <div className={style.appBar}>        
          <div className={style.appBarContainer}>
            <button
              className={classnames(style.navIcon, isOpen && style.isOpen)}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <img src={metadata.coverImgUrl} alt={metadata.title} />
            Inhalt
          </div>
          <img src={metadata.logo} alt={metadata.title} />
        </div>
        <div className={style.mainContainer}>
          <SwiperTracks
            activeTrackId={trackId}
            ubungen={ubungen}
            _onClickPlayerNav={(id) => handleOnClick("track", id)}
            _onClick={() => {
              handleOnClick("detail");
            }}
            _onSwiper={_onSwiper}
            _onSlideChangeTransitionEnd={(s) => {
              if (isDefined(s) && s.activeIndex !== trackId) {
                handleOnClick("track", s.activeIndex);
              }
            }}
            metadata={metadata}
          />
          <div className={classNames(style.detail, style[showDetail])}>
            <Ubung
              ubung={ubungen.find((t) => t.index === trackId)}
              _onClick={() => {
                handleOnClick("track");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

PageLayout.propTypes = {};

export default PageLayout;
